import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class UpdateDepartmentCommand implements IMessage {
    id!: Guid;
    code!: string;
    name!: string;

    public constructor(init?: Partial<UpdateDepartmentCommand>) {
        Object.assign(this, init);
    }

    getMethod = () => "PUT";

    getUrl = () => `/admin/departments/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => {
        return {
            code: this.code,
            name: this.name,
        };
    }
}